<template>
  <div class="c-error c-error--balloon is-active" :style="balloonStyle">
    <div class="c-error__text"><slot /></div>
  </div>
</template>

<script>
// バリデーションエラー吹き出し表示。
// c-error--balloon の表示スタイルをラップし、配置位置や折り返し挙動を呼び出し側からプロパティで制御できるようにする。
// 入力欄が狭い場面でテキストが折り返されたり、入力高さに合わせて位置調整したい場面で props を渡す。
export default {
  name: 'ErrorBalloon',
  props: {
    // 入力欄に対する垂直方向のオフセット (px)。負値で入力欄の上に逃がす。
    // null の場合は基底 CSS の top をそのまま使用する。
    top: { type: Number, default: null },
    // true のとき内部テキストを 1 行に固定し、入力欄の幅を超えても折り返さない。
    nowrap: { type: Boolean, default: false },
  },
  computed: {
    balloonStyle: function() {
      var style = {};
      if (this.top !== null) {
        style.top = this.top + 'px';
      }
      if (this.nowrap) {
        style.whiteSpace = 'nowrap';
      }
      return style;
    },
  },
}
</script>
